import { useVesselTallyStepperActions } from '@host/hooks/useVesselTallyStepperActions'
import { useOperationsStore } from '@tom-ui/operations'
import { NavigationStack, TallyclerkHomePage } from '@tom-ui/planning'
import { observer } from 'mobx-react-lite'

const TallyclerkPageContent = observer(() => {
  const { gangStore } = useOperationsStore()
  const { onWorkAssignmentsSelection } = useVesselTallyStepperActions()

  return (
    <TallyclerkHomePage
      onContinueClick={onWorkAssignmentsSelection}
      gangs={gangStore.items}
      onFetchGangs={() => gangStore.fetchData()}
    />
  )
})

export const TallyclerkPage = () => {
  return (
    <NavigationStack>
      <TallyclerkPageContent />
    </NavigationStack>
  )
}
